import * as icons from '@creditornot/alchemy-react/icons';
import { IconButton } from '@creditornot/cb-button';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useMatchMedia } from 'common/hooks/useMatchMedia';

import { FundingsSearchInput } from './FundingsSearchInput';
import { NavBarButton, NavBarControls } from './styled';
import { vendorFundingsRouteApi } from '../routeApi';

export function FundingsNavBarControls() {
  const navigate = vendorFundingsRouteApi.useNavigate();

  const isMobile = useMatchMedia('maxMd');

  const format = useFormatMessage();

  const openFundingsModal = () =>
    navigate({ search: (prev) => ({ ...prev, fundingsModalOpen: true }) });

  return (
    <NavBarControls gap="regularXlarge" direction="row">
      {!isMobile && <FundingsSearchInput />}
      {isMobile ? (
        <IconButton
          size="small"
          variant="brand"
          icon={icons.share}
          aria-label={format('vendor_fundings.add_fundings')}
          onClick={openFundingsModal}
        />
      ) : (
        <NavBarButton icon={icons.share} variant="primary" size="small" onClick={openFundingsModal}>
          {format('vendor_fundings.add_fundings')}
        </NavBarButton>
      )}
    </NavBarControls>
  );
}
